import { render } from "./AlertIconAlt.vue?vue&type=template&id=1caa42d0"
const script = {}
script.render = render

export default script